import { render, staticRenderFns } from "./BoxIndicadoresWorkflow.vue?vue&type=template&id=71dbd872&scoped=true&"
import script from "./BoxIndicadoresWorkflow.vue?vue&type=script&lang=js&"
export * from "./BoxIndicadoresWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./BoxIndicadoresWorkflow.vue?vue&type=style&index=0&id=71dbd872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dbd872",
  null
  
)

export default component.exports